import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function NcertShortNoteChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="ncertshortnote" />


    </>
  );
}

export default NcertShortNoteChemTopics;